import React from 'react';
import classNames from 'classnames';

import SearchBar from '../SearchBar';
import Link from '../../Link';

import renderIcon from '../../../utils/renderIcon';
import { useKeypressHandler } from '../../../utils/hooks';

const ns = `search-flyout-unbxd`;

const SearchFlyout = ({
	open = false,
	onCloseCallback,
	windowScrolled,
}) => {
	useKeypressHandler('Escape', onCloseCallback);

	const rootClassnames = classNames({
		[`${ ns }`]: true,
		[`${ ns }--closed`]: !open,
		[`${ ns }--scrolled`]: windowScrolled,
	});

	return (
		<div
			role={'presentation'}
			className={rootClassnames}
			onClick={e => e.target === e.currentTarget && onCloseCallback()}
		>
			<div className={`${ ns }__container`}>
				<button className={`${ ns }__close`} onClick={onCloseCallback}>
					<span aria-hidden>{renderIcon('close')}</span>
					<span className={`visually-hidden`}>Close</span>
				</button>
				<div className={`${ ns }__group`}>
					<div className={`${ ns }__logo`}>
						<Link to={`/`} aria-label={`Go home`}>
							{renderIcon('logo')}
						</Link>
					</div>
					<SearchBar isSearchFlyout={open} closeSearchFlyout={onCloseCallback} />
				</div>
			</div>
		</div>
	);
};

export default SearchFlyout;
